import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('FinanceWrapper')(
  css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }),
);

themeStyles.addBaseStyles('FinanceContainer')(
  css({
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    flexDirection: ['column', 'column', 'row'],
  }),
);

themeStyles.addBaseStyles('PaymentFrequencyContainer')(
  css({
    display: 'flex',
    columnGap: 'xs',
    pr: ['zero', 'zero', 'xs'],
  }),
);

themeStyles.addBaseStyles('PaymentColumn')(
  css({
    px: ['zero', 'zero', 'xxs'],
  }),
);

themeStyles.addBaseStyles('PaymentAmountContainer')(
  css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  }),
);

themeStyles.addBaseStyles('EditLabelLink')(
  css({
    color: 'blue',
    textDecoration: 'none',
    border: 'none',
    '&:hover': {
      textDecoration: 'none',
      border: 'none',
    },
  }),
);

themeStyles.addBaseStyles('PaymentLabelCopy')(
  css({
    textAlign: 'center',
    gap: 'xs',
  }),
);

themeStyles.addBaseStyles('PaymentLabelContent')(
  css({
    alignItems: 'baseline',
    display: 'flex',
    gap: 'xxs',
    pt: ['zero', 'zero', '2px'],
  }),
);

themeStyles.addBaseStyles('PaymentContentCopy')(({ fontSize, lineHeight, textAlign = 'center' }) =>
  css({
    textAlign,
    fontFamily: 'bold',
    fontSize,
    lineHeight,
  }),
);

export default themeStyles;
